import React, { useEffect, useRef, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";

import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getInternalSalesData,
  getwarHouseEntityList,
} from "../../services/PartsInventory";
import Dropdown from "react-bootstrap/Dropdown";
import { getSerachUserProfile } from "../../services/ClientProfileServices";
import Select from "react-select";
import {
  exportInternalSales,
  getInternalSalesDetails,
} from "../../services/PartTypeService";
import {
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { getCommonSearchList } from "../../services/settingsServices";
import {
  createInpvoiceInternalSales,
  internalSalesFileUpdate,
  internalSalesInvoicePdf,
  internalSalesRefundStatus,
  internalSalesUpdateStatus,
  updateCompanySalesStatus,
  deleteInvoiceFileInternalSales,
} from "../../services/SalesServices";
import moment from "moment";
import {
  getDocumentSetList,
  getListCustomerList,
} from "../../services/MoloniServices";
import { createSyncInvoiceProduct } from "../../services/moloniProductService";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { tConstStatic } from "../../utils/constantsTranslator";

const covertSalesList = [
  { value: 1, label: "Internal" },
  { value: 2, label: "Marketplace" },
];

const statusColorMap = {
  1: "#f59e0b", // In-Progress
  2: "#3b82f6", // Accepted
  3: "#10b981", // Delivered
  4: "#ef4444", // Cancelled
  5: "#8b5cf6", // Refund
  6: "#f97316", // With Incidence
  7: "#22c55e", // Incidence treated
};

const InternalSales = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [clientFilterData, setClientFilterData] = useState({
    sales_type: "",
    seller_id: "",
    warehouse_id: "",
    date_start: "",
    date_end: "",
    sales_status: "",
  });

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    sales_type: 1,
    seller_id: "",
    warehouse_id: "",
    start_date: "",
    end_date: "",
    sales_status: "",
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [internalSalesDataList, setinternalSalesDataList] = useState([]);
  const [show, setShow] = useState(false);
  const [entityList, setEntityList] = useState([]);
  const [userDataMainList, setUserDataMainList] = useState([]);
  const [modifyconverToSales, setModifyconverToSales] = useState(false);
  const [converToSalesDataList, setConverToSalesDataList] = useState("");
  const [internalSalesData, setInternalSalesData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [statusChangeModal, setStatusChangeModal] = useState(false);
  const [statusChange, setStatusChange] = useState("");
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [modifyModal, setModifyModal] = useState(false);
  const [orderStatusNameList, setOrderStatusNameList] = useState([]);
  const [salesData, setSalesData] = useState({
    sales_status: "",
  });
  const [selectedRadioAccepted, setSelectedRadioAccepted] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  let errorsObj = {
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
    date: "",
    document_set_id: "",
    customer_id: "",
    expiration_date: "",
    your_reference: "",
    our_reference: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [failedData, setFailedData] = useState({
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
  });

  let errorsObjRefund = {
    refund_value: "",
    refund_type: "",
    refund_reason: "",
  };
  const [errorsRefund, setErrorsRefund] = useState(errorsObjRefund);

  const [refundData, setRefundData] = useState({
    refund_value: "",
    refund_type: "",
    refund_reason: "",
  });

  const [modifyAcceptedInternalModal, setModifyAcceptedInternalModal] =
    useState(false);
  const [modifyCancelModal, setModifyCancelModal] = useState(false);
  const [modifyRefundModal, setModifyRefundModal] = useState(false);
  const [refundTypeList, setRefundTypeList] = useState([]);
  const [selectedInternalFiles, setSelectedInternalFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refundLoading, setRefundLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [syncFormData, setSyncFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    expiration_date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    our_reference: "",
    your_reference: "",
    notes: "",
    total_value_packaging: "",
    total_value_other_parcel: "",
    total_value_shipping: "",
    exemption_vat_products: "",
    exemption_vat_shipping: "",
    exemption_vat_packaging: "",
    selected_ids: [],
  });
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [exemptionList, setExemptionList] = useState([]);
  const [modifyAcceptedModal, setModifyAcceptedModal] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [isInvoiceLoad, setIsInvoiceLoad] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageId, setImageId] = useState("");
  const [imageLoader, setImageLoader] = useState(false);
  const [customerModel, setCustomerModel] = useState(false);
  const [customerAllList, setCustomerAllList] = useState("");

  const handleCustomerModelClose = () => {
    setCustomerModel(false);
  };

  const handleCustomerModelOpen = () => {
    setCustomerModel(true);
    let data = {
      uuid: statusChange?.uuid,
    };

    getInternalSalesDetails(data)
      .then((response) => {
        setCustomerAllList(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleFileChangeImage = (event) => {
    const files = Array.from(event.target.files);
    const imageFiles = files.filter((file) => file.type.startsWith("image/"));

    if (imageFiles.length === 0) {
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...imageFiles]);
  };

  const removeImage = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleFileChangeImageInternal = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedInternalFiles([file]);

    // Image preview
    if (file.type.startsWith("image/")) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    } else {
      setImagePreview(null);
    }
  };

  const removeFile = () => {
    setSelectedInternalFiles([]);

    if (imagePreview) {
      URL.revokeObjectURL(imagePreview);
      setImagePreview(null);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    if (imageId) {
      setImageLoader(true);
      const data = { id: imageId, sales_type: 2 };

      deleteInvoiceFileInternalSales(data)
        .then((response) => {
          toast.success(response.data.message);
          setImageLoader(false);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setImageLoader(false);
        });
    }
  };

  const handleAcceptedInternalClose = () => {
    setModifyAcceptedInternalModal(false);

    setSelectedInternalFiles([]);
    setImagePreview(null);

    setFailedData({
      shipping_company: "",
      shipping_tracking_code: "",
      reason_failed_sale: "",
      add_file: "",
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    if (statusChange?.image_list?.length > 0) {
      if (statusChange?.image_list[0]?.file_type === 1) {
        setImagePreview(statusChange?.image_list[0]?.image_url);
        setImageId(statusChange?.image_list[0]?.id);
      }
    }
  }, [statusChange]);

  const handleCancelClose = () => {
    setModifyCancelModal(false);
    setFailedData({
      shipping_company: "",
      shipping_tracking_code: "",
      reason_failed_sale: "",
      add_file: "",
    });
  };

  const handleAcceptedClose = () => {
    setModifyAcceptedModal(false);
    setFailedData({
      shipping_company: "",
      shipping_tracking_code: "",
      reason_failed_sale: "",
      add_file: "",
    });
    setSelectedFiles([])
  };

  const handleRefundClose = () => {
    setModifyRefundModal(false);
    setRefundData({
      refund_value: "",
      refund_type: "",
      refund_reason: "",
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
    } else {
      event.target.value = null;
    }
  };

  const handleRadioInternalSaleChange = (event) => {
    setSelectedRadioAccepted(event.target.value);
  };

  const handleRadioChange = (event) => {
    setSelectedRadio(event.target.value);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "order_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setOrderStatusNameList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCustomerList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        seCustomerList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleStatusChange = (e, item) => {
    e.preventDefault();
    setStatusChange(item);
    setStatusChangeModal(true);
  };

  const onDeleteModalClose = () => {
    setStatusChangeModal(false);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "refund_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setRefundTypeList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSelectChangeRefund = (selectedOption) => {
    setRefundData({
      ...refundData,
      refund_type: selectedOption ? selectedOption.value : "",
    });
  };

  const handleSelectChange = (selectedOption) => {
    setSalesData({
      ...salesData,
      sales_status: selectedOption ? selectedOption.value : "",
    });
    if (selectedOption?.value === 1) {
      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("sales_status", 1);
      internalSalesUpdateStatus(formData)
        .then((response) => {
          toast.success(response.data.message);
          setIsDelButtonLoad(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }

    if (selectedOption?.value === 2) {
      if (statusChange?.sales_status === 2) {
        navigate("/accept-invoice", {
          state: {
            statusChange,
            is_sale_type: 2,
          },
        });
        return; // stop execution
      }

      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("sales_status", 2);

      internalSalesUpdateStatus(formData)
        .then((response) => {
          toast.success(response.data.message);
          setIsDelButtonLoad(false);

          navigate("/accept-invoice", {
            state: {
              statusChange,
              is_sale_type: 2,
            },
          });

          setStatusChangeModal(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }

    if (selectedOption?.value === 3) {
      setModifyAcceptedModal(true);
      setStatusChangeModal(false);
    }

    if (selectedOption?.value === 4) {
      setModifyCancelModal(true);
      setStatusChangeModal(false);
    }

    if (selectedOption?.value === 5) {
      setModifyRefundModal(true);
      setStatusChangeModal(false);
    }

    if (selectedOption?.value === 6) {
      setModifyCancelModal(true);
      setStatusChangeModal(false);
    }

    if (selectedOption?.value === 7) {
      setModifyCancelModal(true);
      setStatusChangeModal(false);
    }
  };

  const handleAddAccpetedStatusInternalSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (selectedRadioAccepted === "1") {
      const formData = new FormData();
      formData.append("internal_sales_id", statusChange.id);
      formData.append("sales_status", 3);
      selectedInternalFiles.forEach((file) => {
        formData.append("order_images", file);
      });
      formData.append("sales_type", 2);

      internalSalesFileUpdate(formData)
        .then((response) => {
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedInternalModal(false);
          setFailedData({
            shipping_company: "",
            shipping_tracking_code: "",
            reason_failed_sale: "",
            add_file: "",
          });
          let data = { ...params };
          fetchPartLocation(data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
          setStatusChangeModal(false);
        });
    }

    if (selectedRadioAccepted === "2") {
      setLoading(true);

      let errorObj = {};
      let hasError = false;

      if (!syncFormData?.date) {
        errorObj.date = "Date is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.document_set_id) {
        errorObj.document_set_id = "Document Set is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.customer_id) {
        errorObj.customer_id = "Customer is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.expiration_date) {
        errorObj.expiration_date = "Expiration Date is required.";
        hasError = true;
      } else if (syncFormData?.date) {
        const start = new Date(syncFormData.date);
        const end = new Date(syncFormData.expiration_date);

        if (end < start) {
          errorObj.expiration_date = "Expiration Date must be after Date.";
          hasError = true;
          setLoading(false);
        }
      }

      if (!syncFormData?.your_reference) {
        errorObj.your_reference = "Your Reference is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.our_reference) {
        errorObj.our_reference = "Our Reference is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.notes) {
        errorObj.notes = "Notes is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.total_value_packaging) {
        errorObj.total_value_packaging = "Total value packaging is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.total_value_other_parcel) {
        errorObj.total_value_other_parcel =
          "Total value other value is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.total_value_shipping) {
        errorObj.total_value_shipping = "Total value shipping is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.exemption_vat_products) {
        errorObj.exemption_vat_products = "Exemption vat products is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.exemption_vat_shipping) {
        errorObj.exemption_vat_shipping = "Exemption vat shipping is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.exemption_vat_packaging) {
        errorObj.exemption_vat_packaging =
          "Exemption vat packaging is required.";
        hasError = true;
        setLoading(false);
      }

      setErrors(errorObj);
      Utils.focusError();

      if (hasError) {
        setLoading(false);
        return;
      }

      let payload = {
        id: statusChange?.id,
        date: syncFormData?.date,
        expiration_date: syncFormData?.expiration_date,
        document_set_id: syncFormData?.document_set_id,
        customer_id: syncFormData?.customer_id,
        our_reference: syncFormData?.our_reference,
        your_reference: syncFormData?.your_reference,
        notes: syncFormData?.notes,
        total_value_packaging: syncFormData?.total_value_packaging,
        total_value_other_parcel: syncFormData?.total_value_other_parcel,
        total_value_shipping: syncFormData?.total_value_shipping,
        exemption_vat_products: syncFormData?.exemption_vat_products,
        exemption_vat_shipping: syncFormData?.exemption_vat_shipping,
        exemption_vat_packaging: syncFormData?.exemption_vat_packaging,
        sales_type: 2,
        button_type: 2,
      };

      createInpvoiceInternalSales(payload)
        .then((response) => {
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedInternalModal(false);
          let data = { ...params };
          fetchPartLocation(data);
          setSyncFormData({
            price_value: "",
            selected_ids: [],
          });
          setLoading(false);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleAddCancelStatusSubmit = (e) => {
    e.preventDefault();
    setCancelLoading(true); // start loader

    let error = false;
    let errorObj = { ...errorsObj };

    if (!failedData.reason_failed_sale) {
      errorObj.reason_failed_sale = "Reason is required.";
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) {
      setCancelLoading(false); // stop loader on validation error
      return;
    }

    const formData = new FormData();
    formData.append("id", statusChange.id);
    formData.append("sales_status", salesData?.sales_status);
    formData.append("reason_failed_sale", failedData.reason_failed_sale);

    internalSalesUpdateStatus(formData)
      .then((response) => {
        toast.success(response.data.message);
        setStatusChange("");
        setModifyCancelModal(false);
        setFailedData({
          shipping_company: "",
          shipping_tracking_code: "",
          reason_failed_sale: "",
          add_file: "",
        });
        let data = { ...params };

        fetchPartLocation(data);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setCancelLoading(false); // always stop loader
        setStatusChangeModal(false);
      });

    setModifyCancelModal(true);
  };

  const handleAddRefundStatusSubmit = (e) => {
    e.preventDefault();
    setRefundLoading(true);

    let error = false;
    let errorObj = { ...errorsObj };

    if (refundData?.refund_type === 2) {
      if (!refundData.refund_value) {
        errorObj.refund_value = "Refund value is required.";
        error = true;
      }
    }

    if (!refundData.refund_type) {
      errorObj.refund_type = "Refund type is required.";
      error = true;
    }

    if (!refundData.refund_reason) {
      errorObj.refund_reason = "Reason is required.";
      error = true;
    }

    setErrorsRefund(errorObj);
    Utils.focusError();

    if (error) {
      setRefundLoading(false); // stop loader on validation error
      return;
    }

    let data = {
      id: statusChange.id,
      sales_status: 5,
      refund_type: refundData.refund_type,
      refund_reason: refundData.refund_reason,
      refund_value: refundData.refund_value || 0,
    };

    internalSalesUpdateStatus(data)
      .then((response) => {
        toast.success(response.data.message);
        setStatusChange("");
        setModifyRefundModal(false);
        setRefundData({
          refund_value: "",
          refund_type: "",
          refund_reason: "",
        });
        let data = { ...params };

        fetchPartLocation(data);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setRefundLoading(false); //  stop loader always
        setStatusChangeModal(false);
      });

    setModifyRefundModal(true);
  };

  useEffect(() => {
    if (statusChange) {
      setSalesData((prevSalesData) => ({
        ...prevSalesData, // Keep previous values
        sales_status: statusChange?.sales_status, // Update only sales_status
      }));
    }
  }, [statusChange]);

  const handleConvertToSaleOpen = (e, item) => {
    setConverToSalesDataList(item);
    setModifyconverToSales(true);
  };

  const handleConvertToSaleClose = () => {
    setModifyconverToSales(false);
  };

  const handleShowOpen = () => {
    setShow(true);
  };

  const handleShowClose = () => {
    setShow(false);
  };

  useEffect(function () {
    const obj = {
      limit: 20,
      page: 1,
      search: "",
    };
    getSerachUserProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setUserDataMainList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      is_reload: false,
    };

    getwarHouseEntityList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.parent_ids,
            label: response.data[i]?.parent_names,
          });
        }
        setEntityList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("filterData");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname, params]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    paramsObj.sales_type = clientFilterData?.sales_type;
    paramsObj.warehouse_id = clientFilterData?.warehouse_id;
    paramsObj.seller_id = clientFilterData?.seller_id;
    paramsObj.start_date = clientFilterData.date_start;
    paramsObj.end_date = clientFilterData.date_end;
    paramsObj.sales_status = clientFilterData.sales_status;
    localStorage.setItem("filterData", JSON.stringify(paramsObj));
    setParams(paramsObj);
    setShow(false);
  };

  useEffect(() => {
    const savedFilterData = localStorage.getItem("filterData");
    if (savedFilterData) {
      const parsedFilterData = JSON.parse(savedFilterData);

      setParams(parsedFilterData);
    }
  }, []);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("filterData"));
    if (savedData) {
      setClientFilterData({
        sales_type: savedData?.sales_type,
        seller_id: savedData?.seller_id,
        warehouse_id: savedData?.warehouse_id,
        sales_status: savedData?.sales_status,
      });
    }
  }, []);

  const ResetModal = () => {
    setParams({
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
      sales_type: 1,
      warehouse_id: "",
      seller_id: "",
      start_date: "",
      end_date: "",
      sales_status: "",
    });
    setClientFilterData({
      sales_type: "",
      seller_id: "",
      warehouse_id: "",
      date_start: "",
      date_end: "",
      sales_status: "",
    });
    setShow(false);
    localStorage.removeItem("filterData");
  };

  const fetchPartLocation = () => {
    let data = { ...params };
    getInternalSalesData(data)
      .then((response) => {
        setinternalSalesDataList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(function () {
    let data = { ...params };

    fetchPartLocation(data);
  }, [params]);

  useEffect(() => {
    if (converToSalesDataList?.uuid) {
      let data = { uuid: converToSalesDataList?.uuid };
      getInternalSalesDetails(data)
        .then((response) => {
          setInternalSalesData(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [converToSalesDataList?.uuid]);

  const fetchExportInternalSales = () => {
    let data = { ...params };
    setIsLoading(true); // Start loader

    exportInternalSales(data)
      .then((response) => {
        const pdfUrl = response?.data?.record?.url;

        if (pdfUrl) {
          window.open(pdfUrl, "_blank");
        } else {
          toast.error(t("toast_pdf_url_not_found"));
        }
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsLoading(false); // Stop loader
      });
  };



  const handleAddAccpetedStatusSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (selectedRadio === "1") {
      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("sales_status", 3);

      // if (statusChange?.seller_takes_care_shipping === true) {
        formData.append("shipping_label", selectedFile);
        formData.append("shipping_company", failedData.shipping_company);
        formData.append(
          "shipping_tracking_code",
          failedData.shipping_tracking_code,
        );
      // }

      selectedFiles.forEach((file) => {
        formData.append("order_images", file);
      });

      internalSalesUpdateStatus(formData)
        .then((response) => {
          let data = { ...params };
          fetchPartLocation(data);
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedModal(false);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
          setStatusChangeModal(false);
        });
    }

    if (selectedRadio === "2") {
      let errorObj = { ...errorsObj };

      if (!failedData.reason_failed_sale) {
        errorObj.reason_failed_sale = "Reason is required.";
        setErrors(errorObj);
        Utils.focusError();
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("order_status", 4);
      formData.append("reason_failed_sale", failedData.reason_failed_sale);

      selectedFiles.forEach((file) => {
        formData.append("images[]", file);
      });

      internalSalesUpdateStatus(formData)
        .then((response) => {
          let data = { ...params };
          fetchPartLocation(data);
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedModal(false);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
          setStatusChangeModal(false);
        });
    }
  };

  const handleInvoiceDownloadPdf = async (e) => {
    e.preventDefault();
    setIsInvoiceLoad(true);

    // const loadingToastId = toast.info("Please wait...", { autoClose: false }); // Show toast while loading

    try {
      let data = {
        uuid: internalSalesData?.uuid,
      };
      const response = await internalSalesInvoicePdf(data);

      if (response?.data?.data?.url) {
        window.open(response.data.data.url, "_blank");
        toast.success(t("toast_pdf_opened_ok"));
      } else {
        toast.error(t("toast_pdf_url_failed"));
      }
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    } finally {
      // toast.dismiss(loadingToastId);
      setIsInvoiceLoad(false);
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <h1 className="page-title">Part Type</h1> */}
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder={t("search")}
                      ></input>
                    </div>

                    {show && (
                      <div
                        className="offcanvas-backdrop show"
                        onClick={(e) => e.stopPropagation()}
                      ></div>
                    )}

                    <div className="card-title m-0 float-right rightBtn">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={() => navigate("/add-internal")}
                      >
                        <i className="bi bi-geo-alt-fill"></i>
                        <span className="ms-2">Add Internal</span>
                      </button>
                      <button
                        type="button"
                        className="btn btn-icon-text mr-2"
                        onClick={fetchExportInternalSales}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          <i className="bi bi-file-earmark-excel-fill"></i>
                        )}
                        <span className="ms-2">{t("export")}</span>
                      </button>

                      <button
                        type="button"
                        className="btn-icon-text mr-2 mr-2"
                        onClick={handleShowOpen}
                      >
                        <i className="bi bi-funnel"></i>
                        {t("filter")}
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive-reserve table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table-striped table-hover">
                        <thead>
                          <tr>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("sales_invoice_no")}
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("reservation_name")}
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("seller_name")}
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("sales_type")}
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Created Date{" "}
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Order Status Name{" "}
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Total price
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("action")}
                            </th>{" "}
                          </tr>
                        </thead>
                        <tbody>
                          {internalSalesDataList?.map((item, index) => (
                            <tr key={item.id}>
                              {" "}
                              <td>{item?.sales_invoice_no}</td>
                              <td>{item?.reservation_name}</td>
                              <td>{item?.seller_name}</td>
                              <td>
                                {item?.sales_type === 1
                                  ? "Internal"
                                  : "MarketPlace"}
                              </td>
                              <td>
                                {item?.created_at
                                  ? moment(item?.created_at).format(
                                      "DD/MM/YYYY",
                                    )
                                  : "-"}
                              </td>
                              <td>
                                <span
                                  style={{
                                    backgroundColor:
                                      statusColorMap[
                                        String(item?.sales_status)
                                      ],
                                    color: "white",
                                    padding: "4px 3px",
                                    borderRadius: "12px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {tConstStatic(item?.sales_status_name)}
                                </span>
                              </td>
                              <td>€ {item?.total_price}</td>
                              <td>
                                <div className="d-flex">
                                  <Dropdown
                                    className="iconDropdown"
                                    onToggle={(isOpen) => {
                                      if (isOpen) {
                                        // This logic runs when the dropdown is opened
                                        const tableResponsive =
                                          document.querySelector(
                                            ".table-responsive",
                                          );
                                        if (window.innerWidth <= 767) {
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "auto !important";
                                            tableResponsive.style.overflowY =
                                              "auto !important";
                                          }
                                        } else {
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "inherit !important";
                                            tableResponsive.style.overflowY =
                                              "inherit !important";
                                          }
                                        }
                                      }
                                    }}
                                  >
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                      className="iconToggle"
                                    >
                                      <i className="bi bi-three-dots-vertical"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        className="d-flex"
                                        onClick={(e) =>
                                          handleConvertToSaleOpen(e, item)
                                        }
                                      >
                                        <button className="edit-btn">
                                          <i className="bi bi-pencil"></i>
                                        </button>
                                        <span>{t("details")}</span>
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        href="#/action-2"
                                        className="d-flex"
                                        onClick={(e) =>
                                          handleStatusChange(e, item)
                                        }
                                      >
                                        <a className="" href="#"></a>

                                        <div className="edit-btn">
                                          <i className="bi bi-arrow-repeat"></i>
                                        </div>
                                        <span>Status Change</span>
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {internalSalesDataList &&
                            internalSalesDataList.length === 0 && (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  {t("no_record_found")}
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer card-footer-part clearfix">
            <div className="pagination pagination-sm m-0 float-right">
              <ReactPaginate
                previousLabel={<i className="bi bi-chevron-double-left"></i>}
                nextLabel={<i className="bi bi-chevron-double-right"></i>}
                breakLabel={"..."}
                pageCount={Math.ceil(totalRecords / params.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handleParams(e, "pagination")}
                forcePage={params.page - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </section>
      </div>

      <div
        className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
        tabIndex="-1"
        id="staticBackdrop"
        aria-labelledby="staticBackdropLabel"
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="staticBackdropLabel"
          >
            {t("filter")}
          </h5>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleShowClose}
          ></button>
        </div>

        <div className="offcanvas-body">
          <div>
            <div href="#/action-2">
              <div className="Label-my">
                Warehouse{" "}
                <Select
                  className="my-select-v"
                  options={entityList}
                  value={
                    entityList.find(
                      (item) => item.value == clientFilterData.warehouse_id,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setClientFilterData({
                      ...clientFilterData,
                      warehouse_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Warehouse"}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                Seller{" "}
                <Select
                  className="my-select-v"
                  options={userDataMainList}
                  value={
                    userDataMainList.find(
                      (item) => item.value == clientFilterData.seller_id,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setClientFilterData({
                      ...clientFilterData,
                      seller_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Seller"}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                Sales Type{" "}
                <Select
                  className="my-select-v"
                  options={covertSalesList}
                  value={
                    covertSalesList.find(
                      (item) => item.value == clientFilterData.sales_type,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setClientFilterData({
                      ...clientFilterData,
                      sales_type: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Sales Type"}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                Sales Status{" "}
                <Select
                  className="my-select-v"
                  options={orderStatusNameList}
                  value={
                    orderStatusNameList.find(
                      (item) => item.value == clientFilterData.sales_status,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setClientFilterData({
                      ...clientFilterData,
                      sales_status: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Sales Status"}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                Start Date
                <input
                  type="date"
                  className="form-control"
                  value={clientFilterData.date_start}
                  onChange={(e) =>
                    setClientFilterData({
                      ...clientFilterData,
                      date_start: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                End Date
                <input
                  type="date"
                  className="form-control"
                  value={clientFilterData.date_end}
                  onChange={(e) =>
                    setClientFilterData({
                      ...clientFilterData,
                      date_end: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-around mb-3">
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary btn-filter"
              onClick={(e) => handleParams(e)}
            >
              <span className="ms-1">{t("filter")}</span>
            </button>
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary ms-1 btn-filter"
              onClick={ResetModal}
            >
              <span className="ms-1 ">Reset</span>
            </button>
          </div>
        </div>
      </div>

      <Modal isOpen={modifyconverToSales} size="xl">
        <ModalHeader className="modal-custom-header">
          {"Sales Details"}
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="card-title m-0 float-right fuelCT">
              <button
                type="button"
                className="btn-icon-text mr-2"
                onClick={handleInvoiceDownloadPdf}
                disabled={isInvoiceLoad}
              >
                {isInvoiceLoad ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    />
                    <span className="ms-2">Loading...</span>
                  </>
                ) : (
                  <>
                    <i className="bi bi-file-pdf-fill"></i>
                    <span className="ms-2">{t("downloadInvoicePdf")}</span>
                  </>
                )}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div
                className="row sales-detail-row"
                style={{
                  marginTop: "10px",
                }}
              >
                <div className="col-md-4 col-sales">
                  Sales invoice no :{internalSalesData?.sales_invoice_no || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Seller Name :{internalSalesData?.seller_name || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Total Part Price :€{" "}
                  {internalSalesData?.total_Part_price || "-"}
                </div>
                <div className="col-md-4 col-sales">
                  Sales Notes :{internalSalesData?.sales_notes || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Shipping Price :€ {internalSalesData?.shipping_price || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Parcel Price :€ {internalSalesData?.parcel_price || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Total Qty :{internalSalesData?.total_qty || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Total VAT Price :€ {internalSalesData?.total_vat_price || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Total Price :€ {internalSalesData?.total_price || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Sales Status Name :€{" "}
                  {tConstStatic(internalSalesData?.sales_status_name) || "-"}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="Label-my mb-2 mt-2">Client Details</div>
            </div>
            <div className="col-md-12">
              <div
                className="row sales-detail-row"
                style={{
                  marginTop: "10px",
                }}
              >
                <div className="col-md-4 col-sales">
                  Client Name :{internalSalesData?.client_name || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Email: {internalSalesData?.client_email || "-"}
                </div>
                <div className="col-md-4 col-sales">
                  Country Code :{internalSalesData?.client_country_code || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  District :{internalSalesData?.client_district || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  City :{internalSalesData?.client_city || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Bill Address :{internalSalesData?.client_bill_address || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Postal Code : {internalSalesData?.client_postal_code || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Country Code:{" "}
                  {internalSalesData?.client_vat_country_code || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Number: {internalSalesData?.client_vat_number || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Percentage(%):{" "}
                  {internalSalesData?.client_vat_percentage || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Exempt:{" "}
                  {internalSalesData?.client_is_vat_exempt === "1"
                    ? "Yes"
                    : "NO" || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Indicative Phone Code:{" "}
                  {internalSalesData?.client_indicative_phone_code || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Phone Code: {internalSalesData?.client_phone_number || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Whatsapp Number:{" "}
                  {internalSalesData?.client_whatsapp_number || "-"}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="Label-my mb-2 mt-2">Shipping Address</div>
              <div
                className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                style={{
                  height: "150px",
                  minHeight: "150px",
                }}
              >
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                    </tr>
                  </thead>

                  <tbody>
                    {internalSalesData?.client_shipping_addresses?.length >
                    0 ? (
                      internalSalesData?.client_shipping_addresses?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item}</td>
                          </tr>
                        ),
                      )
                    ) : (
                      <tr className="scrollBrdr">
                        <td colSpan="100%">No results found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my mb-2 mt-2">Part Details</div>

              <div
                className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                style={{
                  height: "150px",
                  minHeight: "150px",
                }}
              >
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Part Name</th>
                      <th>Warehouse name</th>
                      <th>Sales Order Notes</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {internalSalesData?.part_list?.length > 0 ? (
                      internalSalesData?.part_list?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.product_name}</td>
                          <td>{item?.location_name}</td>
                          <td>{item?.internal_sales_order_notes}</td>
                          <td style={{ cursor: "pointer" }}>
                            <i
                              className="bi bi-eye-fill"
                              onClick={(e) => {
                                e.preventDefault();
                                if (item) {
                                  navigate(
                                    `/part/details/inven/${item.parts_id}`,
                                    {
                                      state: item,
                                    },
                                  );
                                }
                              }}
                            ></i>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="scrollBrdr">
                        <td colSpan="100%">No results found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {internalSalesData?.image_list?.length > 0 && (
            <div className="row">
              <div className="col-md-12">
                <div className="Label-my mb-2 mt-2">Image List</div>

                <PhotoProvider
                  visible={viewerOpen}
                  onVisibleChange={(v) => setViewerOpen(v)}
                  current={viewerIndex}
                  onIndexChange={(i) => setViewerIndex(i)}
                >
                  <div className="card-body card-body-custom">
                    <div className="row justify-content-start">
                      {internalSalesData?.image_list?.map((image, index) => (
                        <div key={index} className="col-sm-3">
                          <div
                            className="column-img"
                            style={{ position: "relative" }}
                          >
                            {/* Image (NOT clickable) */}
                            <PhotoView src={image?.image_url}>
                              <img
                                src={image?.image_url}
                                alt=""
                                style={{
                                  width: "100%",
                                  height: "160px",
                                  objectFit: "cover",
                                  borderRadius: "6px",
                                }}
                              />
                            </PhotoView>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </PhotoProvider>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleConvertToSaleClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyAcceptedInternalModal} size="xl">
        {/* <ModalHeader>{`Status Change`}</ModalHeader> */}
        <ModalBody></ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleAcceptedInternalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddAccpetedStatusInternalSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyCancelModal} size="lg">
        {/* <ModalHeader>{`Status Change`}</ModalHeader> */}
        <ModalBody>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Reason"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <textarea
                        className="form-control input-search"
                        type="text"
                        value={failedData.reason_failed_sale}
                        onChange={(e) => {
                          setFailedData({
                            ...failedData,
                            reason_failed_sale: e.target.value,
                          });
                        }}
                        name={`reason_failed_sale`}
                        rows={3}
                        placeholder={t("reason")}
                      />
                      {errors.reason_failed_sale && (
                        <span className="input-error">
                          {errors.reason_failed_sale}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCancelClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddCancelStatusSubmit}
            disabled={cancelLoading}
          >
            {cancelLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyRefundModal} size="lg">
        <ModalBody>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Refund Type"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div SelectV">
                      <Select
                        className="my-Select"
                        options={refundTypeList}
                        value={refundTypeList.find(
                          (item) => item.value == refundData.refund_type,
                        )}
                        onChange={handleSelectChangeRefund}
                        placeholder={"Select Refund Type"}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Reason"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <textarea
                        className="form-control input-search"
                        type="text"
                        value={refundData.refund_reason}
                        onChange={(e) => {
                          setRefundData({
                            ...refundData,
                            refund_reason: e.target.value,
                          });
                        }}
                        name={`refund_reason`}
                        maxLength={50}
                        placeholder={t("reason")}
                        rows={3}
                      />
                      {errorsRefund.refund_reason && (
                        <span className="input-error">
                          {errorsRefund.refund_reason}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
              {refundData?.refund_type === 2 ? (
                <div className="col-md-6">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my">
                      {"Refund Value"}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <input
                          className="form-control input-search"
                          type="text"
                          value={refundData.refund_value}
                          onChange={(e) => {
                            setRefundData({
                              ...refundData,
                              refund_value: e.target.value,
                            });
                          }}
                          name={`refund_value`}
                          maxLength={50}
                          placeholder={t("refund_value")}
                        />
                        {errorsRefund.refund_value && (
                          <span className="input-error">
                            {errorsRefund.refund_value}
                          </span>
                        )}
                      </div>
                    </div>
                  </FormGroup>
                </div>
              ) : (
                <div className="col-md-6"></div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleRefundClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddRefundStatusSubmit}
            disabled={refundLoading}
          >
            {refundLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={statusChangeModal} size="lg">
        <ModalHeader>{`Status Change`}</ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <FormGroup>
              <Label className="col-form-label ml-2 Label-my form-label form-label">
                {"Order Status"}
              </Label>
              <div className="col-xl-12">
                <div className="input-div SelectV">
                  <Select
                    className="my-Select"
                    options={orderStatusNameList}
                    value={orderStatusNameList.find(
                      (item) => item.value === salesData.sales_status,
                    )}
                    onChange={handleSelectChange}
                    placeholder={"Select Order Status"}
                    isSearchable={true}
                    isClearable={true}
                  />
                </div>
              </div>
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyAcceptedModal} size="lg">
        {/* <ModalHeader>{`Status Change`}</ModalHeader> */}
        <ModalBody>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadio"
                  id="flexRadio1"
                  value="1"
                  checked={selectedRadio === "1"}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="flexRadio1">
                  Add Shipping Details
                </label>
              </div>

              <div className="col-md-6">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadio"
                  id="flexRadio2"
                  value="2"
                  checked={selectedRadio === "2"}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="flexRadio2">
                  Cancelled
                </label>
              </div>

              {selectedRadio === "1" && (
                <>
                  <>
                    <div className="col-md-12" style={{ marginTop: "10px" }}>
                      <a
                        href={statusChange.shipping_label}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-file-earmark-pdf"></i> View PDF
                      </a>
                    </div>

                    <div
                      className="col-md-12 d-none"
                      style={{ marginTop: "10px" }}
                    >
                      <div className="p-4 border rounded-lg">
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={handleFileChangeImage}
                          className="border p-2 rounded-md"
                        />

                        {selectedFiles.length > 0 && (
                          <div className="mt-4 grid grid-cols-3 gap-2">
                            {selectedFiles.map((file, index) => (
                              <div key={index} className="relative">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={`preview-${index}`}
                                  style={{ width: "100px" }}
                                  className="object-cover rounded-lg shadow-md"
                                />
                                <button
                                  onClick={() => removeImage(index)}
                                  className="absolute top-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full"
                                >
                                  ✖
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12" style={{ marginTop: "12px" }}>
                      <div className="p-4 border rounded-lg">
                        <input
                          type="file"
                          accept="application/pdf"
                          onChange={handleFileChange}
                          className="border p-2 rounded-md"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my">
                          {"Shipping Company"}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={failedData.shipping_company}
                              onChange={(e) => {
                                setFailedData({
                                  ...failedData,
                                  shipping_company: e.target.value,
                                });
                              }}
                              name={`shipping_company`}
                              maxLength={50}
                              placeholder={t("shipping_company")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my">
                          {"Shipping tracking code"}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={failedData.shipping_tracking_code}
                              onChange={(e) => {
                                setFailedData({
                                  ...failedData,
                                  shipping_tracking_code: e.target.value,
                                });
                              }}
                              name={`shipping_tracking_code`}
                              maxLength={50}
                              placeholder={t("shipping_tracking_code")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-12">
                      <div className="p-4 border rounded-lg">
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={handleFileChangeImage}
                          className="border p-2 rounded-md"
                        />

                        {selectedFiles.length > 0 && (
                          <div className="mt-4 grid grid-cols-3 gap-2">
                            {selectedFiles.map((file, index) => (
                              <div key={index} className="relative">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={`preview-${index}`}
                                  style={{ width: "100px" }}
                                  className="object-cover rounded-lg shadow-md"
                                />
                                <button
                                  onClick={() => removeImage(index)}
                                  className="absolute top-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full"
                                >
                                  ✖
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                </>
              )}

              {selectedRadio === "2" && (
                <>
                  <div className="col-md-12">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my">
                        {"Reason Failed Sale"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <textarea
                            className="form-control input-search"
                            type="text"
                            value={failedData.reason_failed_sale}
                            onChange={(e) => {
                              setFailedData({
                                ...failedData,
                                reason_failed_sale: e.target.value,
                              });
                            }}
                            name={`reason_failed_sale`}
                            placeholder={t("reason_failed_sale")}
                            rows={3}
                          />
                          {errors.reason_failed_sale && (
                            <span className="input-error">
                              {errors.reason_failed_sale}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-12">
                    <div className="p-4 border rounded-lg">
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleFileChangeImage}
                        className="border p-2 rounded-md"
                      />

                      {selectedFiles.length > 0 && (
                        <div className="mt-4 grid grid-cols-3 gap-2">
                          {selectedFiles.map((file, index) => (
                            <div key={index} className="relative">
                              <img
                                src={URL.createObjectURL(file)}
                                alt={`preview-${index}`}
                                style={{ width: "100px" }}
                                className="object-cover rounded-lg shadow-md"
                              />
                              <button
                                onClick={() => removeImage(index)}
                                className="absolute top-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full"
                              >
                                ✖
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleAcceptedClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddAccpetedStatusSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={customerModel}>
        <ModalHeader>Details</ModalHeader>

        <ModalBody>
          <div className="row">
            <div>
              <>
                <div className="col-md-12">
                  <h6>Name : {customerAllList?.client_details?.name}</h6>
                </div>
                <div className="col-md-12">
                  <h6>
                    Phone : {customerAllList?.client_details?.phone_number}
                  </h6>
                </div>
                <div className="col-md-12">
                  <h6>Email : {customerAllList?.client_details?.email}</h6>
                </div>
                <div className="col-md-12">
                  <h6>
                    Whatsapp :{" "}
                    {customerAllList?.client_details?.whatsapp_number}
                  </h6>
                </div>
                <div className="col-md-12">
                  <h6>
                    VAT Number : {customerAllList?.client_details?.vat_number}
                  </h6>
                </div>
                <div className="col-md-12">
                  <h6>
                    Shipping Address :{" "}
                    {customerAllList?.client_details?.shipping_address?.map(
                      (item, index) => (
                        <p key={index}>{item}</p>
                      ),
                    )}{" "}
                  </h6>
                </div>
                <div className="col-md-12">
                  <h6>
                    Postal Code : {customerAllList?.client_details?.postal_code}
                  </h6>
                </div>{" "}
                <div className="col-md-12">
                  <h6>
                    Country Code VAT Number :{" "}
                    {customerAllList?.client_details?.vat_country_code}
                  </h6>
                </div>{" "}
                <div className="col-md-12">
                  <h6>
                    Country Code :{" "}
                    {customerAllList?.client_details?.country_code}
                  </h6>
                </div>{" "}
                <div className="col-md-12">
                  <h6>City : {customerAllList?.client_details?.city}</h6>
                </div>{" "}
              </>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCustomerModelClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default InternalSales;
